// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__qeO-j","signatureButtonsRight":"ModalSign_signatureButtonsRight__3Z1ga"};